import { setValue } from "../../lib/immutable_wrapper";
import {
    SET_RESULT_SEARCH_AFFAIR,
    SET_FILTERED_AND_SORTED_AFFAIRS,
    SET_SELECTED_TYPE,
    SET_SELECTED_STATE,
    SET_START_DATE,
    SET_END_DATE,
    SET_DISPLAY_ALL_AFFAIRS,
    SET_ALL_AFFAIRS,
    SET_CURRENT_AFFAIR,
    SET_TOTAL_AMOUNT,
    SET_DISPLAY_AS_LIST,
} from "./affairConstants";
import { getStates, getTypes } from "./affairActions";
import { ALL_SELECT_OPTION } from "../../constants";

const initialState = {
    resultSearchAffair: "",
    currentAffair: null,
};

const affairsInitialState = {
    filteredAndSortedAffairs: [],
    allAffairs: [],
    types: getTypes(),
    states: getStates(),
    selectedState: ALL_SELECT_OPTION,
    selectedType: ALL_SELECT_OPTION,
    startDate: null,
    endDate: null,
    displayAllAffairs: false,
    displayAsList: true,
    totalAmount: 0,
};

export function affair(state = initialState, action) {
    switch (action.type) {
        case SET_RESULT_SEARCH_AFFAIR:
            return setValue(state, ["resultSearchAffair"], action.resultSearchAffair);
        case SET_CURRENT_AFFAIR:
            return setValue(state, ["currentAffair"], action.currentAffair);
        default:
            return state;
    }
}

export function affairs(state = affairsInitialState, action) {
    switch (action.type) {
        case SET_FILTERED_AND_SORTED_AFFAIRS:
            return setValue(state, ["filteredAndSortedAffairs"], action.affairs);
        case SET_ALL_AFFAIRS:
            return setValue(state, ["allAffairs"], action.allAffairs);
        case SET_SELECTED_TYPE:
            return setValue(state, ["selectedType"], action.selectedType);
        case SET_SELECTED_STATE:
            return setValue(state, ["selectedState"], action.selectedState);
        case SET_START_DATE:
            return setValue(state, ["startDate"], action.startDate);
        case SET_END_DATE:
            return setValue(state, ["endDate"], action.endDate);
        case SET_DISPLAY_ALL_AFFAIRS:
            return setValue(state, ["displayAllAffairs"], action.displayAllAffairs);
        case SET_DISPLAY_AS_LIST:
            return setValue(state, ["displayAsList"], action.displayAsList);
        case SET_TOTAL_AMOUNT:
            return setValue(state, ["totalAmount"], action.totalAmount);
        default:
            return state;
    }
}
